import TableONGsItem from "./TableONGsItem";

const { __ } = wp.i18n;

function TableONGs({ ONGs }) {

  return (
    <div className="table-ongs">
      <div className="table-header">
        <div className="table-cell table-cell__lealtad">&nbsp;</div>
        <div className="table-cell table-cell__nombre has-text-gray-400-color table-cell__title">
          { __('Nombre de la causa', 'bizum-website') }
        </div>
        <div className="table-cell table-cell__codigo has-text-gray-400-color ">
          { __('Código de envío', 'bizum-website') }
        </div>
        <div className="table-cell table-cell__email has-text-gray-400-color ">
          { __('Email', 'bizum-website') }
        </div>
        <div className="table-cell__website">  
          {/* Sitio web */}
        </div>
      </div>
      {ONGs.map(item => <TableONGsItem key={item.id} ong={item} />)}
    </div>
  )
}

export default TableONGs;